import Accent from './accent';
import Cancel from './cancel';
import Danger from './danger';
import Primary from './primary';
import Secondary from './secondary';
import Success from './success';

const Button = {
  Accent,
  Cancel,
  Danger,
  Primary,
  Secondary,
  Success,
};

export default Button;
